const calcTotalGuests = (tableData, fieldUsage = "NumberOfGuests") => {
  const numbers = tableData.map((data) => Number(data[fieldUsage]));

  return numbers.reduce((a, b) => a + b, 0);
};

export { calcTotalGuests };
